import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import * as UiColors from 'src/app/ui-components/colors';
export const highlightSymbol = () => {
  return new SimpleFillSymbol({
    outline: { width: 6.0, color: UiColors.lightOliveGreen }, //width: 3.25, color: UiColors.lightOliveGreen
    color: null,
  });
};
